import React, { Component } from 'react';
import Modal from '../../helpers/Modal';
import TextArea from '../../forms/TextArea';
import ModalButtons from '../forms/ModalButtons';

class PerformancesSetlistModal extends Component {
    state = { setlistDraft: '' };

    _initializeState = (setlist = '') => {
        this.setState({ setlistDraft: setlist });
    };

    _closeModal = () => {
        this.props.closeModal();
        this._initializeState();
    };

    _saveModal = () => {
        this.props.saveModal(this.state.setlistDraft);
        this._initializeState();
    };

    _onSetlistChange = value => {
        this.setState({ setlistDraft: value });
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
            this._initializeState(this.props.setlist || '');
        }
    }

    render() {
        const { open } = this.props;

        if (!open) return null;

        return (
            <Modal className="is-big is-black" open={open} onClose={this._closeModal}>
                <h4 className="ckp-admin-modal-forms-title ckp-ts-h1">Setlist</h4>
                <TextArea
                    value={this.state.setlistDraft}
                    onChange={this._onSetlistChange}
                    name="setlist"
                    label="Setlist"
                />
                <ModalButtons
                    confirmLabel="Ok"
                    cancelAction={this._closeModal}
                    confirmAction={this._saveModal}
                />
            </Modal>
        );
    }
}

export default PerformancesSetlistModal;
